import { useCallback, useSyncExternalStore } from 'react'

function subscribeScroll(onStoreChange: () => void): () => void {
    window.addEventListener('scroll', onStoreChange, { passive: true })
    return () => window.removeEventListener('scroll', onStoreChange)
}

/** True when window.scrollY has reached `threshold`. */
export function useScrollPast(threshold: number): boolean {
    const getSnapshot = useCallback(
        () => window.scrollY >= threshold,
        [threshold],
    )

    return useSyncExternalStore(subscribeScroll, getSnapshot, () => false)
}
